var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromotions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_Megaphone_1154641",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.877,
    height: 15.053,
    viewBox: "0 0 22.877 15.053",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4877",
    "data-name": "Caminho 4877",
    d: "M99,20.427,109.136,15l2.595,10.592-11.271.788Z",
    transform: "translate(-96.868 -13.69)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4878",
    "data-name": "Caminho 4878",
    d: "M245.52,78.108a.918.918,0,0,1,1.784-.438l1.135,4.814a.893.893,0,1,1-1.7.525Z",
    transform: "translate(-245.496 -70.233)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4879",
    "data-name": "Caminho 4879",
    d: "M71.537,1.254a.893.893,0,1,1,1.7-.525l2.595,10.592a.891.891,0,1,1-1.7.525Z",
    transform: "translate(-58.782 -0.032)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4880",
    "data-name": "Caminho 4880",
    d: "M138.05,143.35v.7c0,.175.162.263.324.263l3.244-.088a.364.364,0,0,0,.324-.35l-.081-.788L143,143v.788a1.393,1.393,0,0,1-1.3,1.576l-3.244.175A1.438,1.438,0,0,1,137,144.05l-.081-.613Z",
    transform: "translate(-131.215 -130.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4881",
    "data-name": "Caminho 4881",
    d: "M2.373,46.719c-.73.175-1.054-1.05-.324-1.226l3.081-.875c.811-.263,1.054.963.324,1.226Z",
    transform: "translate(16.869 -40.682)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4882",
    "data-name": "Caminho 4882",
    d: "M24.419,5.654c-.568.525-1.3-.438-.73-.963l2.433-2.276c.649-.525,1.378.438.811.963Z",
    transform: "translate(-6.151 -2.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4883",
    "data-name": "Caminho 4883",
    d: "M.836,84.833c-.73-.175-.973,1.138-.162,1.225l3.162.613c.73.175.892-1.05.162-1.226Z",
    transform: "translate(18.405 -77.395)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotions);
export default __webpack_public_path__ + "static/media/promotions.81612f46.svg";
export { ForwardRef as ReactComponent };